/**
 * Store the users current Workspace. Should be loaded from WorkspaceStorage.
 *
 * Includes the full row as stored in the `workspaceData` table.
 */
import { SET_WORKSPACE } from "../actionTypes.js";
import { mergeReducer } from "./common/index.js";
export default mergeReducer(SET_WORKSPACE, null);
//# sourceMappingURL=workspace.js.map